type StrapiEntity = Record<string, unknown>

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object'
}

export const isAbortError = (error: unknown): boolean => {
  return error instanceof DOMException && error.name === 'AbortError'
}

export const readString = (value: unknown): string | null => {
  return typeof value === 'string' ? value : null
}

export const toStrapiEntity = (value: unknown): StrapiEntity | null => {
  if (!isRecord(value)) {
    return null
  }

  if (isRecord(value.data)) {
    if (isRecord(value.data.attributes)) {
      return value.data.attributes
    }

    return value.data
  }

  if (isRecord(value.attributes)) {
    return value.attributes
  }

  return value
}

export const toStrapiEntityCollection = (value: unknown): StrapiEntity[] => {
  if (Array.isArray(value)) {
    return value
      .map((entry) => toStrapiEntity(entry))
      .filter((entry): entry is StrapiEntity => Boolean(entry))
  }

  if (!isRecord(value) || !Array.isArray(value.data)) {
    return []
  }

  return value.data
    .map((entry) => toStrapiEntity(entry))
    .filter((entry): entry is StrapiEntity => Boolean(entry))
}

export const extractStrapiMediaUrl = (value: unknown, baseUrl: string): string | null => {
  const mediaEntity = toStrapiEntity(value)

  if (!mediaEntity) {
    return null
  }

  const mediaUrl = readString(mediaEntity.url)

  if (!mediaUrl) {
    return null
  }

  try {
    return new URL(mediaUrl, baseUrl).toString()
  } catch {
    return null
  }
}
